import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import type { RangePickerProps } from 'antd/es/date-picker';
import { message } from 'antd';
import { resolveApiBaseUrl } from './apiBaseUrl';
dayjs.extend(utc);
dayjs.extend(timezone);
// dayjs.utc().tz('Australia/Sydney');
const phoneNumChange = value => {
    const phoneNumber = value.replace(/[^\d]/g, '');
    if (phoneNumber.charAt(0) === '4') {
        return phoneNumber.length < 9
            ? phoneNumber
            : `${phoneNumber.substring(0, 3)} ${phoneNumber.substring(3, 6)} ${phoneNumber.substring(6, 9)}`;
    } else {
        return phoneNumber.length < 10
            ? phoneNumber
            : `${phoneNumber.substring(0, 4)} ${phoneNumber.substring(4, 7)} ${phoneNumber.substring(7, 10)}`;
    }
};
const formatStartTime = (time: string) => {
    const start = dayjs(time).unix();
    const now = dayjs().unix();
    const jetLag = start - now;
    if (jetLag < 60) {
        // 小于1分钟 -Less than 1 minute
        return '';
    }
    const days = Math.floor(jetLag / (24 * 60 * 60));
    const hours = Math.floor((jetLag % (24 * 60 * 60)) / (60 * 60));
    const minutes = Math.floor((jetLag % (60 * 60)) / 60);

    if (days > 0) {
        return `${days} ${days > 1 ? 'Days' : 'Day'}`;
    } else if (hours > 0) {
        return `${hours} ${hours > 1 ? 'Hours' : 'Hour'}`;
    } else {
        return `${minutes} ${minutes > 1 ? 'Mins' : 'Min'}`;
    }
};
const formatChatTime = (time: string) => {
    const today = dayjs().format('YYYY-MM-DD');
    const sendDay = dayjs(time).format('YYYY-MM-DD');
    const thisYear = dayjs().get('year');
    const sendYear = dayjs(time).get('year');
    if (sendDay === today) {
        return dayjs(time).format(`HH:mm`);
    }
    if (sendYear === thisYear) {
        return dayjs(time).format(`DD MMM`);
    } else {
        return dayjs(time).format(`DD MMM YYYY`);
    }
};
const timeFormat = (time: string) => {
    const hour = dayjs(time).hour();
    const minute = dayjs(time).minute();
    const times = dayjs().set('hour', Number(hour)).set('minute', Number(minute));
    return times.format('h:mm A');
};
const taskTimeFormat = (
    // startDate: string | undefined,
    startTime: string | undefined,
    // endDate: string | undefined,
    endTime: string | undefined
) => {
    const today = dayjs();
    const isToday = dayjs(startTime).isSame(today, 'day');

    if (dayjs(startTime).isSame(dayjs(endTime), 'day')) {
        return `${dayjs(startTime).format('h:mm A')}~${
            dayjs(endTime).format('h:mm A,') + (isToday ? 'Today' : dayjs(startTime).format('D MMM YYYY'))
        }`;
    } else {
        return `${dayjs(startTime).format('h:mm A, D MMM YYYY')} to ${dayjs(endTime).format('h:mm A, D MMM YYYY')}`;
    }
};
const formatPrice = (amount: string) => {
    if (!amount) return '';
    return `${Number(amount.split('.')[0]).toLocaleString('en-us')}.${amount.split('.')[1]}`;
};
/**
 *
 * @param val - 数值
 * @param max - 最大值
 * @param decimals - 支持小数
 * @param min - 最小值
 * @returns
 */
export const numberInput = (val: string, max = 0, decimals = true, min = 0) => {
    let checkPlan = '' + val;
    if (decimals) {
        checkPlan = checkPlan
            .replace(/[^\d.]/g, '')
            .replace(/\.{2,}/g, '.')
            .replace(/^\./g, '')
            .replace('.', '$#$')
            .replace(/\./g, '')
            .replace('$#$', '.');
        if (checkPlan.indexOf('.') < 0 && checkPlan !== '') {
            checkPlan = parseFloat(checkPlan) + '';
        } else if (checkPlan.indexOf('.') >= 0) {
            checkPlan = checkPlan.replace(/^()*(\d+)\.(\d\d).*$/, '$1$2.$3');
        }
    } else {
        checkPlan = checkPlan.replace(/[^\d]/g, '');
    }

    const numValue = parseFloat(checkPlan || '0');
    if (!isNaN(numValue)) {
        if (min && numValue < min) {
            return min;
        }
        if (max && numValue > max) {
            return max;
        }
    }
    return checkPlan;
};
export const disabledDate: RangePickerProps['disabledDate'] = current => {
    return current && current > dayjs().endOf('day');
};
export const disabledDateValidity: RangePickerProps['disabledDate'] = current => {
    return current && current < dayjs().add(-1, 'day').endOf('day');
};
export const scrollInto = (id?: string, className?: string) => {
    if (id) {
        const el = document.getElementById(id);
        el && el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    if (className) {
        const el = document.getElementsByClassName(className);
        el.length && el[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
};
export const handleExportUsageData = async (
    path: 'coupon' | 'voucher',
    id: string,
    name: string,
    callBack?: () => void
) => {
    await fetch(`${resolveApiBaseUrl()}/${path}/export/usage/${id}`, {
        headers: {
            'faastaa-admin-satoken': sessionStorage.getItem('faastaa-admin-satoken') || '',
        },
    }) // 替换为你的文档 URL
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.blob(); // 获取 Blob 对象（适用于二进制文件）
        })
        .then(blob => {
            // 创建一个下载链接
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `${name} Usage Data.csv`; // 设置下载文件名
            document.body.appendChild(a);
            a.click(); // 触发下载
            window.URL.revokeObjectURL(url); // 释放内存
            a.remove();
        })
        .catch(error => {
            console.error('Error downloading the file:', error);
        })
        .finally(() => {
            callBack && callBack();
        });
};
export const handleExportCodes = async (id: string, name: string, callBack?: () => void) => {
    await fetch(`${resolveApiBaseUrl()}/voucher/export/code/${id}`, {
        headers: {
            'faastaa-admin-satoken': sessionStorage.getItem('faastaa-admin-satoken') || '',
        },
    })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                return response.json();
            } else {
                return response.blob();
            }
        })
        .then((res: any) => {
            if (res.type && res.type === 'text/csv') {
                const url = window.URL.createObjectURL(res);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${name}_Code List.csv`;
                document.body.appendChild(a);
                a.click();
                window.URL.revokeObjectURL(url);
                a.remove();
            }
            if (res.message) message.error(res.message);
        })
        .catch(() => {
            message.error('Looks like the connection lost. Please try again in a moment.');
        })
        .finally(() => {
            callBack && callBack();
        });
};

/**
 * B2B Partner Tasks → Excel.
 *
 * The workbook is built server-side (EasyExcel) so the download covers every row matching the
 * filters, not just the page on screen — the client never pages through the list to assemble it.
 * Raw `fetch` for the same reason the other exports use it: the axios interceptor is built for
 * the JSON envelope and would mangle a binary body. Errors still come back as that envelope,
 * so the content type decides how the response is read.
 *
 * `params` mirrors the list filters (keyword / sourceType / productStatus / taskerId /
 * assemblyDateStart / assemblyDateEnd); blank values are dropped rather than sent empty.
 */
export const exportBusinessAdminJobs = async (params: Record<string, string | number | undefined>) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            query.append(key, String(value));
        }
    });

    const response = await fetch(`${resolveApiBaseUrl()}/business-admin-job/export?${query.toString()}`, {
        headers: {
            'faastaa-admin-satoken': sessionStorage.getItem('faastaa-admin-satoken') || '',
        },
    });

    const contentType = response.headers.get('content-type') || '';
    if (!response.ok || contentType.includes('application/json')) {
        // A rejected export answers with the usual { code, data, message } envelope.
        const body = await response.json().catch(() => null);
        // Session-expiry codes normally land in the axios interceptor, which this download
        // bypasses — without this the admin would just get a toast and no way back in.
        if (body && [5000, 5001, 5002, 5003, 5004].includes(body.code)) {
            sessionStorage.clear();
            window.location.hash = '#/login';
        }
        throw new Error(body?.message || 'Export failed. Please try again in a moment.');
    }

    const blob = await response.blob();
    // Stamped so repeated downloads sit side by side instead of overwriting each other.
    const fileName = `B2B-Partner-Tasks-${dayjs().format('YYYY-MM-DD_HHmm')}.xlsx`;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
    return fileName;
};

export default { phoneNumChange, formatStartTime, taskTimeFormat, formatChatTime, formatPrice };
